module.exports = __webpack_public_path__ + "static/media/Intelo-ExtraBold.7f3be6a8.ttf";